let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6YVlG")).then(() => parcelRequire('4a8Ly'));